export const APPLICANT = 'applicant';
export const SPOUSE = 'spouse';
export const CHILDREN = 'children';
export const AGREEMENTS = 'agreements';
export const FORM = 'form';
